import React from 'react';
import { SectionHeading } from '../SectionHeading';
import { ProductImage } from '../ProductImage';
import { CtaButton } from '../CtaButton';
import { productIndicators } from '../../data/salesContent';
export function ProductShowcaseSection() {
  const left = productIndicators.slice(0, 3);
  const right = productIndicators.slice(3);
  return <section className="bg-ink-soft px-5 py-20 md:py-28" data-id="element-167" data-mp="1c9n5zzasj14">
      <div className="mx-auto max-w-7xl" data-id="element-168" data-mp="xzea3zkp7qop">
        <SectionHeading title="Todo esto es lo que recibís hoy" subtitle="3 volúmenes + 5 bonos" data-id="element-169" data-mp="y2jyfcli6ojd" />
        <div className="mt-14 grid items-center gap-8 lg:grid-cols-[220px_1fr_220px]" data-id="element-170" data-mp="u0yq84jwyyfi">
          <IndicatorList items={left} align="right" data-id="element-171" data-mp="p6b1q5owu40x" />
          <ProductImage className="mx-auto w-full max-w-3xl" data-id="element-172" data-mp="k9kij9ht6sba" />
          <IndicatorList items={right} align="left" data-id="element-173" data-mp="k785naqwr853" />
        </div>
        <p className="mt-14 text-center font-display text-3xl font-black uppercase text-cream md:text-5xl" data-id="element-174" data-mp="1hpzstb62ffcv">
          Todo en un <span className="text-gold" data-id="element-175" data-mp="1cvn7evl13tyh">solo sistema.</span>
        </p>
        <div className="mt-10" data-id="element-176" data-mp="2ze6c5sdgeags">
          <CtaButton data-id="element-177" data-mp="2zey854ayqa7l">Quiero acceder al sistema</CtaButton>
        </div>
      </div>
    </section>;
}
function IndicatorList({
  items,
  align
}: {
  items: typeof productIndicators;
  align: 'left' | 'right';
}) {
  return <ul className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:grid-cols-1 lg:gap-6" data-id="element-178" data-mp="2um52me7o6xug">
      {items.map(({
      label,
      icon: Icon
    }) => <li key={label} className={`flex items-center gap-3 rounded-2xl border border-gold/30 bg-ink px-5 py-4 ${align === 'right' ? 'lg:flex-row-reverse lg:text-right' : ''}`} data-id="element-179" data-mp="2gm40ywjkzmdx">
          <Icon className="h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-180" data-mp="27mqsa63a71u9" />
          <span className="text-base font-semibold text-cream md:text-lg" data-id="element-181" data-mp="2bmr7hsy7fh2d">{label}</span>
        </li>)}
    </ul>;
}